import React from 'react';
import { Typography, Chip, CardContent, Divider, LinearProgress } from '@material-ui/core';
import { CallMade } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux';
import { setConfirmationDialog } from '../redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { returnMaterialByQuantity } from '../../helperFunctions';

export default ({ device }) => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  const showTaskDetails = useSelector(state => state.tasks.showTaskDetails);
  const task = data.tasks.find(x => x.id === showTaskDetails.taskId);
  const fontSize = width <= 500 ? '4vw' : '20px';
  const {
    id,
    deviceGroupId,
    deviceType,
    serialNumber,
    phoneNo,
    protNo,
    mac,
    username,
    password,
    pin,
    ip,
    gateway,
    subnetMask,
    natip,
    deviceUrl,
    monitoringUrl,
  } = device;

  const getMonitoringUrl = msisdn =>
    `${process.env.REACT_APP_SEMPRESSO_URL}/dashboard/direct-session-link?domainName=fixed&msisdn=${msisdn}`;

  const returnToCell = async (deviceId, deviceSerialNumber) => {
    dispatch(
      setConfirmationDialog({
        open: true,
        title: [
          {
            text: `Сигурни ли сте че искате да върнете устройство ${deviceSerialNumber}  в клетката си?`,
          },
        ],
        onConfirm: () =>
          returnMaterialByQuantity(deviceSerialNumber, deviceId, task, data, dispatch),
        onCancel: () =>
          dispatch(
            setConfirmationDialog({
              open: false,
              title: [],
              onConfirm: null,
              onCancel: null,
            })
          ),
      })
    );
  };

  return !data.isReturnMaterialByQuantityLoading ? (
    <CardContent key={id} style={{ marginBottom: '3px' }}>
      {deviceType && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Тип: {deviceType}
        </Typography>
      )}
      {serialNumber && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Сериен номер: {serialNumber}
        </Typography>
      )}
      {deviceGroupId === 10 && phoneNo && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          CardNo: {phoneNo}
        </Typography>
      )}
      {deviceGroupId === 10 && protNo && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          ChipNo: {protNo}
        </Typography>
      )}
      {username && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Username: {username}
        </Typography>
      )}
      {password && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Password: {password}
        </Typography>
      )}
      {ip && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          IP: {ip}
        </Typography>
      )}
      {subnetMask && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Subnet Mask: {subnetMask}
        </Typography>
      )}
      {gateway && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Gateway: {gateway}
        </Typography>
      )}
      {mac && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          Мак адрес: {mac}
        </Typography>
      )}
      {natip && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          VLAN: {natip}
        </Typography>
      )}
      {pin && (
        <Typography gutterBottom component="h2" style={{ fontSize }}>
          PIN: {pin}
        </Typography>
      )}
      {deviceUrl && (
        <Chip
          avatar={<CallMade fontSize="small" />}
          onClick={() => window.open(deviceUrl, '_blank')}
          label="OSS Устройства"
          clickable
          style={{ fontSize, margin: '1px' }}
        />
      )}
      {monitoringUrl && (
        <Chip
          avatar={<CallMade fontSize="small" />}
          onClick={() => window.open(monitoringUrl, '_blank')}
          label="Мониторинг"
          clickable
          style={{ fontSize, margin: '1px' }}
        />
      )}
      {task && task?.lastMsisdn && (
        <Chip
          avatar={<CallMade fontSize="small" />}
          onClick={() => window.open(getMonitoringUrl(task.lastMsisdn), '_blank')}
          label="Мониторинг Sempresso"
          clickable
          style={{ fontSize, margin: '1px' }}
        />
      )}
      <Chip
        label="Зачисли в клетка"
        clickable
        style={{ fontSize, margin: '1px' }}
        onClick={() => returnToCell(id, serialNumber)}
      />
      <Divider style={{ marginTop: '3px' }} />
    </CardContent>
  ) : (
    <LinearProgress />
  );
};
